import { useEffect, useMemo } from 'react';
import Grid from '@mui/material/Grid';
import { Paragraph } from 'src/interviews/components/Layout/Embedded';
import DifferentialCard from 'src/interviews/components/DifferentialCard';
import Divider from '@mui/material/Divider';
import { trackOtherMatches } from '../../analytics';

import type { IInterviewResults, MiniInterviewType } from 'src/packages/polaris/types';

function OtherMatches({
  result,
  interviewToken,
  interviewType,
}: {
  result: IInterviewResults;
  interviewToken: string;
  interviewType: MiniInterviewType;
}) {
  const otherMatches = useMemo(
    () => result.diagnosis_of_concern?.other_matches || [],
    [result.diagnosis_of_concern?.other_matches],
  );

  useEffect(() => {
    trackOtherMatches(interviewToken || '', interviewType, otherMatches);
  }, [interviewToken, interviewType, otherMatches]);

  if (!otherMatches?.length) {
    return null;
  }

  return (
    <>
      <Grid item className="bp-my-4">
        <Divider />
      </Grid>
      <Grid item className="bp-w-full">
        <Paragraph className="!bp-mb-3 bp-w-full bp-text-base bp-font-bold">
          Other matches to consider:
        </Paragraph>

        <div className="bp-no-scrollbar bp-flex bp-gap-3 bp-overflow-x-scroll">
          {otherMatches.map((match) => (
            <div className="bp-flex bp-max-w-[262px] bp-shrink-0" key={match.token}>
              <DifferentialCard differential={match} showTreatmentPlan />
            </div>
          ))}
        </div>
      </Grid>
    </>
  );
}

export default OtherMatches;
